import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

export async function redirectToCheckoutAnalyse(analysisId, sessionToken = null) {
  const body = { analysis_id: analysisId };
  if (sessionToken) body.session_token = sessionToken;
  const { data } = await axios.post(
    `${API_URL}/api/create-checkout-session-analyse`,
    body,
    { withCredentials: true }
  );
  window.location.href = data.url;
}

export async function redirectToCheckoutPremium() {
  const { data } = await axios.post(
    `${API_URL}/api/create-checkout-session-premium`,
    {},
    { withCredentials: true }
  );
  window.location.href = data.url;
}
